import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import CmsStore from '../../stores/CmsStore';
import 'date-format-lite';
import Error404 from 'epic-fortnite-react/components/error/Error404';

/**
 * Terms & Policy View
 */
@connectToStores
class TermsView extends React.Component {
  static propTypes = {
    cmsStore: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
  };

  static getStores() {
    return [CmsStore];
  }

  static getPropsFromStores() {
    return {
      cmsStore: CmsStore.getState(),
    };
  }

  render() {
    const activeSlug = this.props.match.params.slug;
    const {cmsStore} = this.props;

    if (
      !cmsStore?.pages[activeSlug] ||
      !cmsStore.pages[activeSlug].data ||
      cmsStore.pages[activeSlug].error
    ) {
      return <Error404 />;
    }

    const data = cmsStore.pages[activeSlug].data;

    return (
      <div className="terms-view-container">
        <div className="site-block">
          <div className="terms-text" dangerouslySetInnerHTML={{__html: data.content}} />
        </div>
      </div>
    );
  }
}

export default withRouter(TermsView);
